
// 患者住所
export class PatientAddress {
  public phoneNumber: string;
  public zipCode: string;
  public address: string;

  clone(): PatientAddress {
    const newObj = new PatientAddress();
    newObj.phoneNumber = this.phoneNumber;
    newObj.zipCode = this.address;

    return newObj;
  }
}
